import * as React from 'react'
import Menu from '@mui/material/Menu'
import { useState } from 'react'

// style
import { Drawer, IconButton, Typography } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import { Box } from '@mui/system'

import { UserSeeMore } from '../../../../components/Modals/Suborganizations/Users/RightModals/UserSeeMore'

import useStyles from './Styles/useStyles'

export default function ModalMenuItem ({ item, setLoading }) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const [stateSeeMore, setstateSeeMore] = useState(false)

  const handleClickButton = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const listSeeMoreUser = (anchor) => (
    <Box className={classes.stepperStyleSeeMore} role="presentation">
      <UserSeeMore
        style={{ marginTop: '5%' }}
        setLoading={setLoading}
        setstateSeeMore={setstateSeeMore}
        item={item}
      />
    </Box>
  )

  return (
    <>
      <MoreVertIcon
        sx={{
          color: '#026873',
          '&:hover': {
            color: '#00FFAC'
          }
        }}
        onClick={handleClickButton}
      />

      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList onClose={handleClose} setstateSeeMore={setstateSeeMore} />
      </Menu>

      <Drawer anchor={'right'} open={stateSeeMore}>
        {listSeeMoreUser('right')}
      </Drawer>
    </>
  )
}

function FiltersList ({ onClose, setstateSeeMore }) {
  const classes = useStyles()

  return (
    <Box
      sx={{
        width: 200
      }}
      className={classes.boxStyle}
      onClick={onClose}
    >
      <IconButton
        onClick={() => {
          onClose()
          setstateSeeMore(true)
        }}
      >
        <Box className={classes.boxTypography}>
          <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
          <Typography className={classes.typographyStyle}>
            Ver detalles
          </Typography>
        </Box>
      </IconButton>
    </Box>
  )
}
